<template lang="html">
<div Style="margin-top:50px">
  <div>
    <div style="float:left;font-size:16px;text-align:center;line-height: 35px;margin-left: 1%">完成状态:</div>
    <el-select v-model="selectValue" :size="selectSize" placeholder="点击以筛选" style="float:left;margin-left:1%">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <div style="float: left;margin-left: 2%;text-align: center;line-height: 35px;font-size: 16px">标题/内容:</div>
    <el-input placeholder="输入标题或内容用以检索"  v-model="findStr" prefix-icon="el-icon-search" style="width:180px;float:left;margin-left:1%" autofocus="first_input" clearable>
    </el-input>
    <el-button type="primary" icon="icon-search" class="iconfont icon-search" style="float:left;margin-left:2%" @click="getdata">搜索</el-button>
  </div>
  <div style=""></div>
  <div class="infinite-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="5" infinite-scroll-delay="2000" style="float:center;height:500px;width:100%;overflow:auto">
    <div v-for="item in countData" class="infinite-list-item">
      <div class="card-content">
        <el-card class="box-card">
          <div class="notice-card-num notice-card-num-no" v-if="item.state == 3" @click="toUpdateNoticeState(item.num, item.state, item.counts)">未读</div>
          <div class="notice-card-num notice-card-num-un" v-if="item.state == 2" @click="checkData(item.num, item.counts)">处理</div>
          <div class="notice-card-num notice-card-num-finish" v-if="item.state < 2" @click="checkData(item.num, item.counts)">完成</div>
          <div slot="header" class="clearfix">
            <div class="notice-card-titles">{{item.titles}}</div>
            <div class="notice-card-time">{{item.createTime}}</div>
          </div>
          <div>
            <div class="notice-card-body">{{item.bodys}}</div>
          </div>
        </el-card>
      </div>
      </div>
  </div>
  <el-dialog title="处理记录" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :show-close="false" width="200px" :close-on-click-modal="false">
    <el-form :model="form2">
      <el-form-item label="标题" :label-width="formLabelWidth">
        <div style="float:left">{{form2.titles}}</div>
        <div style="margin-right:110px;float:right">{{form2.createTime}}</div>
      </el-form-item>
      <el-form-item label="内容" :label-width="formLabelWidth">
        <el-input type="textarea" autosize v-model="form2.bodys" placeholder="此处显示报警内容" :disabled="true" auto-complete="off" style="width:410px;"></el-input>
      </el-form-item>
      <el-form-item label="处理结果" :label-width="formLabelWidth">
        <el-input type="textarea" autosize v-model="form2.remarks" placeholder="请填入您的处理结果" v-if="form2.state == 2" auto-complete="off" style="width:410px;"></el-input>
        <div v-if="form2.state != 2">{{form2.remarks}}</div>
      </el-form-item>
      <el-form-item label="处理时间" :label-width="formLabelWidth" v-if="form2.state == 1">
        <div style="float:left">{{form2.finishTime}}</div>
      </el-form-item>
      <el-form-item label="有无通知用户" :label-width="formLabelWidth">
        <el-tooltip :content="form2.notifyState ? '已通知' : '暂无'" placement="top">
          <el-switch
            v-model="form2.notifyState"
            active-color="#13ce66"
            inactive-color="#ff4949"">
          </el-switch>
        </el-tooltip>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="toUpdateNotice(form2.counts)">提 交</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import { expire } from '@/utils/auth'
import { fetch } from '@/utils/api'
import { formateDate } from '@/utils/common'
export default {
  data () {
    return {
      busy: false,
      dataDelayed: 1000,
      selectValue: 0,
      selectSize: 10,
      showCon: true,
      findStr: '',
      count: 0,
      countData: [],
      page: 0,
      pageSize: 10,
      init: true,
      first_input: true,
      formLabelWidth: '100px',
      dialogFormVisible: false,
      options: [{
        value: 3,
        label: '未读'
      }, {
        value: 2,
        label: '待处理'
      }, {
        value: 1,
        label: '已处理'
      }, {
        value: 0,
        label: '全部'
      }],
      tmpData: {},
      value: '',
      form2: {
        ids: '',
        titles: '',
        bodys: '',
        createTime: '',
        finishTime: '',
        notifyState: true
      }
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  created () {
    console.log(1)
  },
  methods: {
    getdata () {
      this.countData = []
      this.init = true
      this.loadMore()
    },
    loadMore () {
      if (!this.init) return
      this.busy = true
      this.count += 10
      // 开始访问后台
      fetch({
        url: '/notice/base',
        params: {
          state: this.selectValue,
          filter: this.findStr,
          page: this.page,
          pageSize: this.pageSize
        }
      }).then(data => {
        for (let i = 0; i < data.length; i++) {
          this.tmpData = {}
          this.tmpData.num = data[i].id
          this.tmpData.titles = data[i].title
          this.tmpData.bodys = data[i].body
          this.tmpData.state = data[i].state
          this.tmpData.createTime = formateDate(data[i].createTime)
          this.tmpData.counts = this.countData.length
          this.countData.push(this.tmpData)
        }
      })
      this.busy = false
    },
    checkData (nums, counts) {
      // 查找单条通知消息
      fetch({
        url: '/notice/findOne',
        params: {
          id: nums
        }
      }).then(data => {
        this.form2.ids = data.id
        this.form2.titles = data.title
        this.form2.bodys = data.body
        this.form2.remarks = data.remark
        this.form2.state = data.state
        this.form2.createTime = formateDate(data.createTime)
        this.form2.notifyState = (data.notifyState === 1)
        this.form2.counts = counts
        if (data.finishTime != null) {
          this.form2.finishTime = formateDate(data.finishTime)
        }
        this.dialogFormVisible = true
      })
    },
    updateStates (counts, state) {
      this.countData[counts].state = state
      let tmp1 = this.countData
      this.countData = []
      this.countData = tmp1
    },
    toUpdateNoticeState (nums, state, counts) {
      // 修改后台状态为已读，并调用处理框
      fetch({
        url: '/notice/readOne',
        params: {
          id: nums,
          state: state
        }
      }).then(data => {
        if (data === 1) {
          this.updateStates(counts, 2)
        }
      })
    },
    toUpdateNotice (counts) {
      let notifyState = this.form2.notifyState ? 1 : 0
      // 保存修改\
      fetch({
        url: '/notice/saveOne',
        params: {
          id: this.form2.ids,
          remark: this.form2.remarks,
          notifyState: notifyState
        }
      }).then(data => {
        this.dialogFormVisible = false
        this.updateStates(counts, 1)
      })
    }
  }
}
</script>
<style scoped lang="sass">
.float-left
  float: left
.box-card
  height: 240px
.card-content
  width: 18.8%
  float: left
  margin-left: 1%
  margin-top: 20px
.notice-card-body
  float: left
  overflow: hidden
  text-overflow: ellipsis
  height: 130px
  font-size: 12px
.notice-card-titles
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  width: 70%
.notice-card-num
  font-size: 11px
  float: right
  padding: 3px 0
  border: 2px solid
  border-radius: 100%
  text-align: center
  color: white
  top: 20px
  right: 10px
  position: absolute
.notice-card-num-no
  border-color: #F56C6C
  background-color: #F56C6C
.notice-card-num-un
  border-color: #E6A23C
  background-color: #E6A23C
.notice-card-num-finish
  border-color: #67c23a
  background-color: #67c23a
.box-card
  position: relative
.notice-card-time
  color: #908a8a
  font-size: 6px

</style>


// WEBPACK FOOTER //
// NoticeView.vue?7b51724b